import { ALL_SELECT_OPTION_ITEM } from '../../common/constants'

const DEFAULT_DISH_LIST_FILTERS = {
  MENU_TITLE: null,
  HAS_ERRORS: false,
  IGNORED: null,
  CERTAINTY: ALL_SELECT_OPTION_ITEM.value,
  SEARCH: '',
  TIER: null,
  CURATOR_ID: null,
  QA_ID: null,
  IS_AVAILABLE_FOR_WORK: true,
  WAS_DONE_IN_PREVIOUS_TWO_WEEKS: null,
  IS_NOT_CHECKED: false,
  DISH_TYPE_ID: null,
  COURSE_TYPE_ID: null,
}

export default DEFAULT_DISH_LIST_FILTERS
